import i18n from "i18next";
import { initReactI18next } from "react-i18next";

function getBrowserLanguage() {
  const lang = navigator.language || "pt-BR";
  return lang.split("-")[0];
}

const resources = {
  pt: {
    translation: {
      app: {
        title: "Inbound Automation",
        subTitle: "Inbound Automation",
        description: "Gestão avançada de documentos fiscais.",
        syncStatusTooltip: "Status da sincronização com o banco de dados",
        lastSync: "Última Sincronização",
        defaultUser: "Usuário",
      },
      filters: {
        title: "Filtros de Pesquisa",
        status: "Status",
        accessKey: "Chave de Acesso",
        process: "Processo",
        issueDate: "Data de Emissão",
        receivedDate: "Data de Criação",
        docType: "Tipo Doc.Fiscal",
        search: "Buscar",
        step: "Etapas",
        supplier_cnpj: "CNPJ Fornecedor",
        plant: "Centro",
        dateRangeError: "A data inicial não pode ser maior que a data final",
        fetchError: "Erro ao buscar dados",
        dateFrom: "Data Inicial",
        dateTo: "Data Final",
        accessKeyPlaceholder: "44 dígitos",
      },
      status: {
        all: "Todos",
        authorized: "Autorizado",
        rejected: "Rejeitado",
        cancelled: "Cancelado",
        success: "Sucesso",
        error: "Erro",
        saved: "Salvo",
        duplicated: "Duplicado",
        loading: "Processando",
        pending: "Pendente",
        warning: "Atenção",  
 
      },
      process: {
        Shopping: "Compras",
        Retorn: "Returno",
        Consumption: "Consumo",
      },
      step: {
        create: "Criar Documento",
        xml: "Validar XML",
        validate: "Validar Processo",
      },
      docType: {
        nfe: "NFe",
        cte: "CTe",
      },
      nfeTable: {
        title: "Documentos Fiscais",
      },
      table: {
        empty: "Nenhum registro encontrado.",
      },
      menu: {
        columns: "Colunas",
        manageColumns: "Gerir Colunas",
      },
      buttons: {
        processing: "Processamento e Etapas",
        reprocess: "Reprocessar",
        viewSteps: "Ver Etapas",
        displayDocAux: "Exibir Doc. Auxiliar",
        enterDanfe: "Entrar Danfe",
        documents: "Documentos Gerados",
        customization: "Opções Customizadas",
        saveLayout: "Savar Layout",
        retoreLayout: "Restaurar Layout",
        bNext: "Próximo",
        bClose: "Fechar",
        bSave: "Salvar",
        continue: "Continuar Processo",
        simulate: "Similar Lançamento",
        enterqty: "Entrar Quantidade",
        material: "Correlação Material",
        unit: "Correlação Unidade de Medida",
        reference: "Informar | Corrigir Referência",
        redetermine: "Redeterminar Processo",
        purchase: "Buscar pedido",
        menuDanfe: "Danfe",
        menuDacte: "DACTE",
        ShowDanfe: "Exibir Danfe",
        ShowDacte: "Exibir DACTE",
        consultarStatus: "Consultar Status",
        rejeitar: "Rejeitar",
        rejeitarDesconhecimento: "Desconhecimento da Operação",
        rejeitarNaoRealizada: "Operação não Realizada",
        assign: "Atribuir Documento de Compra",
        unassign: "Desatribuir",
        conversion: "Conversão U.M.",
        bSimulate: "Simular",
        bEnablePhysicalReceipt: "Habilitar Recebimento Físico",
        duplicateItem: "Duplicar Item",
        deleteItem: "Apagar NF-e",
        deleteCte: "Apagar CT-e",
        deleteConfirmTitle: "Confirmar exclusão",
        deleteConfirmMsg: "Tem certeza que deseja apagar",
        deleteConfirmSuffix: "nota(s) fiscal(is)? Esta ação não pode ser desfeita.",
        bDelete: "Apagar",
        uploadXml: "Upload XML",
        uploadSend: "Enviar XML",
        bpdf: "Gerar PDF",
        print: "Imprimir",
        download: "Download",
        settings: "Configurar colunas",
        export: "Exportar",
        bRestore: "Restaurar padrão",
        bCancel: "Cancelar",
        bConfirm: "Confirmar",
        bClear: "Limpar",
        bProcess: "Processar",
        clearFilters: "Limpar Filtros",
        details: "Detalhes",
        xml: "XML",
        history: "Histórico",
        actions: "Ações",
        quickView: "Vista Rápida",
        syncNow: "Sincronizar Dados Agora",
        exportExcel: "Download Excel",
        downAllDanfe: "Download DANFE em massa",
        downAllXml: "Download XML em massa",

      },
      columns: {
        accessKey: "Chave",
        messages: "Msg",
        company: "Empresa",
        plant: "Centro",
        supplierCnpj: "CNPJ Fornecedor",
        supplierCpf: "CPF Fornecedor",
        supplierName: "Nome Fornecedor",
        destCnpj: "CNPJ Destinatário",
        destName: "Nome Destinatário",
        cfop: "CFOP",
        process: "Processo",
        step: "Etapa",
        xmlVersion: "Versão XML",
        nfeNumber: "NF-e",
        series: "Série",
        issueDate: "Data Emissão",
        issueTime: "Hora Emissão",
        createdDate: "Data Criação",
        createdTime: "Hora Criação",
        sefazLog: "Log SEFAZ",
        sefazStatus: "Status SEFAZ",
        processStatus: "Status Proc.",
        rejectCode: "Cód. Rej.",
        ufOrigin: "UF Origem",
        ufDest: "UF Destino",
        totalValue: "Valor Total",
        sefazEvent: "Evento SEFAZ",
        sequentialStep: "Sequencia Etapa",
        executionDate: "Data de Execução",
        executionTime: "Hora de Execução",
        userName: "Usuário",
        status: "Status",
        errorDescription: "Descrição do Erro",
        amount: "Valor",
        date: "Data",
        cteNumber: "Nº CT-e",
        carrierName: "Transportadora",
        carrierCnpj: "CNPJ Transportadora",
        natOp: "Natureza da Operação",
        rntrc: "RNTRC",
        modal: "Modal",
      },
      details: {
        taxdata: "Dados Fiscais",
        issuer: "Emitente",
        recipient: "Destinatário",
        number: "Número e Série NFe:",
        dateTime: "Data e Hora de Emissão:",
        purpose: "Finalidade de Emissão (NFe):",
        accesskey: "Chave de Acesso:",
        operation: "Natureza de Operação:",
        protocol: "Número de Protocolo:",
        dateReceived: "Data e Hora Recebimento SEFAZ:",
        codStatus: "Código de Status:",
        name: "Nome:",
        cnpj: "CNPJ",
        address: "Endereço",
        ie: "Inscrição Estadual",
        title: "Detalhes do Documento Fiscal - NFe",
        header: "Cabeçalho",
        item: "Item",
        total: "Total",
        transport: "Transporte",
        payment: "Pagamento",
        additionalData: "Dados Adicionais",
        itemsList: "Lista de Itens",
        itemDetails: "Detalhamento do Item",
        itemTaxDetails: "Detalhamento de Imposto do Item",
        productCode: "Código Produto",
        productDesc: "Descrição do Produto",
        ncm: "NCM",
        benefitCode: "Código Benefício Fiscal",
        cfop: "CFOP",
        eanTrib: "Código EAN Tributável",
        orderItem: "Pedido / Item",
        uomCom: "Unidade Medida Comercial",
        qtyCom: "Quantidade Comercial",
        unitPrice: "Valor Unitário",
        productValue: "Valor Produto",
        uomTrib: "Unidade Medida Tributável",
        qtyTrib: "Quantidade Tributável",
        unitPriceTrib: "Valor Unitário Tributável",
        icms: "ICMS",
        ipi: "IPI",
        pis: "PIS",
        cofins: "COFINS",
        origem: "Origem",
        cst: "CST",
        framework: "Código de Enquadramento"
      },
      total: {
        baseCalc: "Valor Base de Cálculo:",
        icms: "Valor ICMS:",
        icmsDesonerado: "Valor ICMS Desonerado:",
        fcpUfDest: "Valor FCP UF Dest.:",
        icmsUfDest: "Valor ICMS UF Dest.:",
        icmsUfRemet: "Valor ICMS UF Remet.:",
        fcp: "Valor FCP:",
        baseCalcSt: "Base de Cálculo ST:",
        st: "Valor ST:",
        fcpSt: "Valor FCP ST:",
        fcpStRet: "Valor FCP ST Ret:",
        productValue: "Valor Produto:",
        freight: "Valor Frete:",
        insurance: "Valor Seguro:",
        discount: "Valor Desconto:",
        ii: "Valor II:",
        ipi: "Valor IPI:",
        ipiDev: "Valor IPI Dev:",
        pis: "Valor PIS:",
        cofins: "Valor COFINS:",
        others: "Valor Outros:",
        nf: "Valor NF:",
      },
      transport: {
        freightMode: "Modo Frete:",
        cnpj: "CNPJ:",
        name: "Nome:",
        ie: "Inscrição Estadual",
        address: "Endereço",
        city: "Município",
        uf: "UF:",
        volumeTitle: "Volume",
        volumeQty: "Quantidade Volume:",
        volumeKind: "Espaço",
        netWeight: "Peso Líquido",
        grossWeight: "Peso Bruto",
        carrierTitle: "Transportadora",
      },
      payment: {
        invoice: "Fatura",
        invoiveNumber: "Número da Fatura",
        value: "Valor Original",
        discount: "Valor Desconto", 
        netValue: "Valor Líquido",
        duplicate: "Duplicata",
        numberDuplicate: "Número Duplicata",
        dueDate: "Data Vencimento",
        valueDuplicate: "Valor Duplicata",
        details: "Detalhe do Pagamento",
        indicator: "Indicador de Forma de Pagamento",
        paymentMethod: "Forma de Pagamento",
        paymentAmount: "Valor Pagamento"
      },
      additional: {
        title: "Informações Adicionais"
      }, 
      assing: {
        title: " Atribuição Documento de Compras ",
        assing: "Atribuição de pedido",
        item: "Item NFe",
        itemDescr: "Descrição Item",
        qty: "Quantidade",
        unit: "Unid. Medida NFe",
        purchaseOrderItem: "Doc.Compras / Item",
        purchaseOrder: "Doc.Compras SAP",
        poItem: "Item Pedido",
        purchaseItem: "Item Doc. Compras SAP",
        purchaseOrderItemDescr: "Descrição Item",
        processType: "Tipo de Processo",
        numberNfe: "Número Nfe",
        emitterName:"Nome do Emissor",
        emitterCnpj: "CNPJ do Emissor",
        nameDest: "Nome do Destinatário",
        cnpjDest: "CNPJ do Destinatário",
        itemCtg: "Ctg. de Item",
        materialXml: "XML Material",
        descMaterialXml: "XML Descrição Material",
        materialErp: "ERP Material",
        descMaterialErp: "ERP Descrição Material",
        pendingItems: "Itens NF-e pendentes",
        pendingOrder: "Itens do pedido disponíveis",
        message: "Mensagem",
        unitErp: "Unid. Medida ERP",
        unitMeasurementConversion: "Conversão de Unidade de Medida",
        msgid: "ID / Nº"

      },
      enterQty: {
        title: "Entrar Quantidade",
        receipt: "Recebimneto",
        deposit: "Depósito",
        center: "Centro",
        batch: "Lote",
        subitem: "Subitem",
        select: "Selecione",
        message: "Mensagem",
        batchRequired: "Lote obrigatório",
        warehouseRequired: "Depósito obrigatório",
        invalidQty: "Quantidade inválida",
        qtyExceeded: "Item {{itemKey}}: quantidade total informada ({{splitQty}}) maior que a quantidade do item ({{originalQty}}).",
        qtyBelow: "Item {{itemKey}}: quantidade total informada ({{splitQty}}) menor que a quantidade do item ({{originalQty}}).",
        tableErrors: "Existem erros na tabela. Corrija antes de salvar.",
        dataSaved: "Dados salvos com sucesso.",
        saving: "Salvando... Criando entrada de mercadoria.",
        saveSuccess: "Entrada de mercadoria criada com sucesso!",
        saveError: "Erro: {{msg}}",

      },
      document:{
        title: "Documentos Gerados",
        noDocuments: "Nenhum documento gerado encontrado.",
      },
      simulate: {
        title: "Escotta Inbound Automation - Simulação - NFe",
        generalData: "Dados Gerais",
        taxesCalculated: "Impostos Calculados",
        message: "Mensagem",
        material: "Material",
        origem: "Origem do Material",
        ncm: "NCM",
        qty: "Quantidade",
        uom: "Unidade de Medida",
        totalValue: "Valor Total",
        qtyPo: "Quantidade Pedido de Compra",
        purchaseOrder: "Doc.Compras / Item",
        itemType: "Tipo de Item",
        cfop: "CFOP",
        iva: "Código de Imposto",
        taxDocumentData: "Dados Doc. Fiscal",
        simulationData: "Dados Simulação",
        item: "Item",
      },
      uploadXml: {
        title:  "Upload XML NF-e/ CT-e",
        pageTitle: "Upload XML NF-e / CT-e",
        subtitle: "Importação de arquivos XML",
        description: "Selecione ou arraste arquivos XML de NF-e para envio.",
        dragTitle: "Arraste os arquivos XML aqui",
        dragSubtitle: "ou clique para selecionar os arquivos no computador",
        selectFiles: "Selecionar arquivos",
        selectedFiles: "Arquivos selecionados",
        empty: "Nenhum arquivo XML selecionado até o momento.",
        errorProcess: "Erro ao processar XML",
        errorUpload: "Erro ao enviar XML",
      },
      history:{
        title: "Histórico do Documento Fiscal",
        subtitle: "Histórico",
        documents: "Documento: ",
        fetchError: "Erro ao buscar histórico",
      },
      danfe:{
        noneFound: "Nenhuma DANFE encontrada.",
        productData: "Dados dos Produtos / Serviços",
        printedIn: "Impresso em ",
        productCode: "Códido do Produto",
        description: "Descrição do Produto / Serviço",
        ncm: "ncm",
        cst: "cst",
        cfop: "cfop",
        un: "un",
        qty: "quant",
        unitValue: "Valor Unit",
        totalValue: "Valor Total",
        bicms: "B. Cálc ICMS",
        vicms: "Valor ICMS",
        vipi: "Valor IPI",
        ticms: "Alíq ICMS",
        tipi: "Alíq IPI",
        messageReceipt: " Recebemos de {{nameEmit}} os produtos e/ou serviços constantes a nota fiscal eletrômicaindicada abaixo. Emissão: {{date}} Valor total: {{totalValue}} destinatáeio: {{nameDest}}",
        dateReceipt: "Data de Recebimento",
        identSing: "Identificação e Assinatura do Recebedor",
        nfe: "NF-e",
        number: "Nº",
        serie: "Série",
        destReme: "Destinatário / Remetente",
        companyName: "Nome / Razão Social",
        cnpj: "CNPJ / CPF",
        dateIssue: "Data da Emissão",
        address: "Endereço",
        neighborhood: "Bairro / Distrito",
        cep: "CEP",
        arrivalDate: "Data da Saída / Entrada",
        arrivalTime: "Hora Saída / Entrada",
        local: "Município",
        uf: "UF",
        fone: "Fone / Fax",
        ie: "Inscrição Estadual",
        invoice: "Fatura / Duplicata",
        num: "Num.",
        dueDates: "Venc.",
        value:  "Valor",
        taxCalculation: "Cálculo do Imposto",
        vicmsufr: "V. ICMS UF Remet.",
        vicmsufd:"V. FCP UF Dest.",
        totalValueP: "V. Total Produtos",
        shippingCost: "Valor do Frete",
        insuranceValue: "Valor do Seguro",
        discount: "Desconto",
        otherExpenses: "Outras Despesas",
        totalTaxedVvalue: "V. Tot. Trib.",
        totalValueReceipt: "Valor Total da NOta",
        transporter: "Transportador / Volumes Trabsportados",
        shippingCosts: "Frete Por Conta",
        anttCode: "Código ANTT",
        vehiclePlate: "Placa do Veículo",
        species: "Espécie",
        mark: "Marca",
        numbering: "Numeração",
        grossWeight: "Peso Bruto",
        additionalInformation: "Informações Complementares",
        reservedTaxAuth: "Reservado ao Fisco",
        additionalData: "Dados Adicionais",
        issueridentification: "Identificação do Emitente",
        danfe: "danfe",
        auxiliaryInvoice: "Documento Auxiliar da Nota",
        electronicTax: "Fiscal Eletrônica",
        entry: "0 - Entrada",
        exit: "1 - Saída",
        sheet: "Folha",
        accessKey: "Chave de Acesso", 
        verificationAuthenticity: "Consulta de autenticidade no portal nacional da NF-e",
        sefazWebsite: "www.nfe.fazenda.gov.br/portal ou no site da Sefaz Autorizadora",
        natureOperation: "Natureza da Operação",
        authorizationProtocol: "Protocolo de Autorização de Uso",
        iest: "Inscrição Estatudal do Subst. Tribut.",
        im: "Inscrição Municipal",
        invoce: "Fatura / Duplicata",
        bicmsst: "Base de Cálc. ICMS S.T.",
        vicmsst: "Valor do ICMS Subst.",
        vii: "V.IMP.Importação",
      },
      assignment: {
        simNoMessages: "Simulação concluída sem mensagens.",
        simError: "Erro na simulação: {{msg}}",
        saveSuccess: "Pedido atribuído com sucesso.",
        unassignSuccess: "Desatribuição salva com sucesso.",
        saveSuccessContinuing: "Pedido atribuído com sucesso. Continuando processo...",
      },
      errors: {
        noRowSelected: "Nenhuma linha selecionada",
        accessKeyNotFound: "Access key não encontrada na linha selecionada",
        xmlNotReturned: "XML não retornado pelo servidor",
      },
      log: {
        title: "Ver mensagens de erro",
        subtitle: "Mensagens do Processo",
        step: "Etapa",
        sequentialStep: "Sequencial",
        Status: "Status",
        number: "ID/ Nº",
        message: "Mensagem",
      },
      message: {
      msg0001: "Não encontrei os dados da NF no state. Volte para a lista e selecione uma NF para atribuir.",
      msg0002: "Nenhum item de pedido encontrado para os critérios informados",
      msg0003: "item(ns) de pedido encontrado(s).",
      msg0004: "Selecione um item do XML e um item do pedido para atribuir.",
      msg0005: "Não foi possível localizar os itens selecionados.",
      msg0006: "Atribuição realizada com sucesso",
      msg0007: "Atribuição não encontrada.",
      msg0008: "Dados salvos com sucesso.",
      msg0009: "Item XML {{item}} atribuído ao pedido {{po}}/{{poItem}}.",
      msg0010: "Selecione uma atribuição para desatribuir.",
      msg0011: "Atribuição removida do item XML {{item}}.",
      msg0012: "Conversão cadastrada: {{fromUom}} → {{toUom}} (fator {{factor}}).",
      msg0013: "O item XML {{item}} já está atribuído.",
      msg0014: "XML inválido.",
      msg0015: "Erro ao ler XML",
      msg0016: "Selecione pelo menos um arquivo XML válido.",
      msg0017: "Erro ao processar XML.",
      msg0018: "Nenhum arquivo selecionado",
      erroBuscaPedido: "Não foi possível consultar os pedidos no SAP PI. {{detalhe}}",


      },
      api: {
        accessKey: {
          required: "Chave de acesso é obrigatória",
          arrayRequired: "Array de chaves de acesso é obrigatório",
        },
        nfe: {
          notFound: "NF-e não encontrada",
        },
        items: {
          fetchError: "Erro ao buscar itens",
          saveError: "Erro ao salvar dados",
        },
        documents: {
          fetchError: "Erro ao buscar documentos",
        },
        header: {
          fetchError: "Erro ao buscar notas fiscais",
        },
        history: {
          fetchError: "Erro interno ao buscar histórico",
        },
        xml: {
          notFound: "XML não encontrado para a chave de acesso informada",
          fetchError: "Erro ao buscar XML",
          generateError: "Erro ao gerar arquivos XML",
        },
        upload: {
          noDocument: "Nenhum documento enviado",
        },
        danfe: {
          generateError: "Erro ao gerar PDFs das DANFEs",
        },
        assignment: {
          locked: "Item bloqueado por outro usuário",
          stepNotFound: "Etapa de atribuição não encontrada para este processo",
          saveError: "Erro ao salvar atribuição",
        },
        delete: {
          required: "Lista de chaves de acesso é obrigatória",
          error: "Erro ao apagar NF-e",
        },
        process: {
          fetchError: "Erro ao buscar processos",
        },
        steps: {
          fetchError: "Erro ao buscar etapas",
        },
        continue: {
          locked: "Item bloqueado por outro usuário",
          stepPending: "A etapa atual do item ainda não está concluída",
          error: "Erro ao continuar processamento",
        },
      },
      admin: {
        pages: {
          certificados: "Certificados Digitais",
          empresas: "Empresas",
          processos: "Processos",
          cfop: "Determinação de CFOP",
          etapas: "Etapas do Processo",
          integrationLog: "Log de Integração",
        },
        col: {
          cnpj: "CNPJ",
          empresa: "Empresa",
          tempoJob: "Tempo Job (s)",
          lastNsu: "Último NSU",
          certificado: "Certificado",
          razaoSocial: "Razão Social",
          codSap: "Cód. SAP",
          centro: "Centro",
          ativaCol: "Ativa",
          codigo: "Código",
          descricao: "Descrição",
          cfop: "CFOP",
          processo: "Processo",
          etapa: "Etapa",
          funcaoTx: "Função TX",
          automaticaCol: "Automática",
          obrigatoriaCol: "Obrigatória",
          dataHora: "Data / Horário",
          tipo: "Tipo",
          payloadEnvio: "Payload envio",
          payloadRetorno: "Payload retorno",
        },
        grid: {
          certificados: "Certificados por Empresa",
          empresas: "Empresas Cadastradas",
          processos: "Tipos de Processo",
          etapas: "Etapas Configuradas",
          cfop: "Vínculo CFOP × Processo",
        },
        dialog: {
          confirmDelete: "Confirmar Exclusão",
          editCertificado: "Editar Certificado",
          newCertificado: "Novo Certificado",
          editEmpresa: "Editar Empresa",
          newEmpresa: "Nova Empresa",
          editProcesso: "Editar Processo",
          newProcesso: "Novo Processo",
          editCfop: "Editar CFOP",
          newCfop: "Novo CFOP",
          editEtapa: "Editar Etapa",
          newEtapa: "Nova Etapa",
          callDetails: "Detalhes da chamada",
        },
        required: {
          empresa: "Empresa obrigatória",
          cnpj: "CNPJ obrigatório",
          cfop: "CFOP obrigatório",
          processStep: "Processo e etapa obrigatórios",
          processCode: "Código do processo obrigatório",
        },
        success: {
          certUpdated: "Certificado atualizado",
          certSaved: "Certificado salvo",
          certDeleted: "Certificado(s) excluído(s)",
          empresaUpdated: "Empresa atualizada",
          empresaCreated: "Empresa criada",
          empresaDeleted: "Empresa(s) excluída(s)",
          processUpdated: "Processo atualizado",
          processCreated: "Processo criado",
          processDeleted: "Processo(s) excluído(s)",
          cfopUpdated: "CFOP atualizado",
          cfopCreated: "CFOP criado",
          cfopDeleted: "CFOP(s) excluído(s)",
          stepUpdated: "Etapa atualizada",
          stepCreated: "Etapa criada",
          stepDeleted: "Etapa excluída",
        },
        confirm: {
          deleteCertificado: "Excluir {{count}} certificado(s)? Esta ação não pode ser desfeita.",
          deleteEmpresa: "Excluir {{count}} empresa(s)? Esta ação não pode ser desfeita.",
          deleteProcesso: "Excluir {{count}} processo(s)? Esta ação não pode ser desfeita.",
          deleteCfop: "Excluir {{count}} CFOP(s)? Esta ação não pode ser desfeita.",
          deleteEtapa: "Excluir a etapa selecionada? Esta ação não pode ser desfeita.",
        },
        buttons: {
          cancel: "Cancelar",
          deleting: "Excluindo...",
          delete: "Excluir",
          buscar: "Buscar",
          limpar: "Limpar",
          verDetalhes: "Ver detalhes",
          close: "Fechar",
        },
        label: {
          empresaAtiva: "Empresa ativa",
          ativa: "Ativa",
          automatica: "Automática",
          obrigatoria: "Obrigatória",
          todos: "Todos",
        },
        helper: {
          certBase64: "Cole o conteúdo do certificado A1 (PFX) em Base64",
          certPassword: "Senha do arquivo PFX (deixe vazio se sem senha)",
          functionTx: "Ex: SAVE_NFE_XML, ZF_ASSIGN_PURCHASE_ORDER",
        },
        filter: {
          all: "Todos",
          none: "— Nenhum —",
          filtros: "Filtros",
          tipoIntegracao: "Tipo de integração",
          data: "Data",
          cnpj: "CNPJ",
          status: "Status",
        },
        detail: {
          dataHora: "DATA / HORÁRIO",
          tipo: "TIPO",
          cnpj: "CNPJ",
          status: "STATUS",
        },
      },
      sefaz: {
        distribute: {
          cardTitle: "Distribuição de Documentos Fiscais Eletrônicos",
          cardDesc: "Solicita à SEFAZ todos os DFe de interesse do CNPJ a partir do último NSU recebido. Documentos NF-e completos são importados automaticamente.",
          empresa: "Empresa (Certificado)",
          lastNsu: "Último NSU:",
          nsuResetTooltip: "Reiniciar NSU — próxima consulta buscará todos os documentos desde o início",
          nsuReset: "NSU reiniciado — próxima consulta trará todos os documentos",
          nsuResetError: "Erro ao reiniciar NSU",
          selectCompany: "Selecione uma empresa",
          noNewDocs: "Nenhum documento novo na SEFAZ",
          docsReceived: "{{count}} documento(s) recebido(s) — {{saved}} salvo(s)",
          noNewDocsFound: "Nenhum documento novo encontrado na SEFAZ para este CNPJ.",
          docsReceivedTitle: "Documentos recebidos ({{count}})",
          savedCount: "{{count}} salvo(s)",
          errorsCount: "{{count}} erro(s)",
          querying: "Consultando SEFAZ...",
          distribute: "Distribuir DFe",
          colNsu: "NSU",
          colTipo: "Tipo",
          colChave: "Chave de Acesso",
          colStatus: "Status",
          colDetalhe: "Detalhe",
        },
        schema: {
          procNFe: "NF-e Completa",
          resNFe: "NF-e Resumo",
          procCTe: "CT-e Completo",
          resCTe: "CT-e Resumo",
          procEvento: "Evento Completo",
          resEvento: "Evento Resumo",
        },
        status: {
          saved: "Salvo",
          xmlUpdated: "XML atualizado",
          alreadyExists: "Já existente",
          received: "Recebido",
          error: "Erro",
          warning: "Atenção" 
        },
        consulta: {
          title: "Consulta de Status — SEFAZ {{uf}}",
          protocol: "Protocolo",
          dhProtocolo: "Data Protocolo",
          dhRecbto: "Data Resposta",
          detalhe: "Detalhe",
        },
      },
      nfe: {
        error: {
          assignmentNotAllowed: "Atribuição não permitida para a etapa atual do documento.",
          assignmentNotAllowedStep: "Atribuição não permitida. Próxima etapa: {{step}}",
          qtyNotAllowed: "Entrar Quantidade não permitido para a etapa atual do documento.",
          qtyNotAllowedStep: "Entrar Quantidade não permitido. Próxima etapa: {{step}}",
        },
        validation: {
          justificationMin: "Justificativa deve ter no mínimo 15 caracteres.",
          justificationHelper: "{{length}}/255 — mínimo 15 caracteres",
        },
        evento: {
          successDesconhecimento: "Evento \"Desconhecimento da Operação\" enviado com sucesso.",
          successNaoRealizada: "Evento \"Operação não Realizada\" enviado com sucesso.",
          confirmDesconhecimento: "Confirma o envio do evento de Desconhecimento da Operação para esta NF-e?",
          justificativaLabel: "Informe a justificativa para Operação não Realizada (15–255 caracteres):",
        },
      },
      toolbar: {
        today: "Hoje",
        at: "às"
      }
    },
  },
  en: {
    translation: {
      app: {
        title: "Inbound Automation",
        subTitle: "Inbound Automation",
        description: "Advanced fiscal document management.",
        syncStatusTooltip: "Database synchronization status",
        lastSync: "Last Sync",
        defaultUser: "User",
      },
      filters: {
        title: "Search Filters",
        status: "Status",
        accessKey: "Access Key",
        process: "Process",
        issueDate: "Issue Date",
        receivedDate: "Creation Date",
        docType: "Fiscal Doc. Type",
        search: "Search",
        step: "Steps",
        supplier_cnpj: "Supplier CNPJ",
        plant: "Plant",
        dateRangeError: "Start date cannot be greater than end date",
        fetchError: "Error fetching data",
        dateFrom: "Start Date",
        dateTo: "End Date",
        accessKeyPlaceholder: "44 digits",
      },
      status: {
        all: "All",
        authorized: "Authorized",
        rejected: "Rejected",
        cancelled: "Cancelled",
        success: "Success",
        error: "Error",
        saved: "Saved",
        duplicated: "Duplicated",
        loading: "Processing",
        pending: "Pending",
        warning: "Warning", 
      },
      process: {
        Shopping: "Purchasing",
        Retorn: "Return",
        Consumption: "Consumption",
      },
      step: {
        create: "Create Document",
        xml: "Validate XML",
        validate: "Validate Process",
      },
      docType: {
        nfe: "NFe",
        cte: "CTe",
      },
      nfeTable: {
        title: "Fiscal Documents",
      },
      table: {
        empty: "No records found.",
      },
      menu: {
        columns: "Columns",
        manageColumns: "Manage Columns",
      },
      buttons: {
        processing: "Processing & Steps",
        reprocess: "Reprocess",
        viewSteps: "View Steps",
        displayDocAux: "Display Aux. Doc.",
        enterDanfe: "Enter Danfe",
        documents: "Generated Documents",
        customization: "Custom Options",
        saveLayout: "Save Layout",
        retoreLayout: "Restore Layout",
        bNext: "Next",
        bClose: "Close",
        bSave: "Save",
        continue: "Continue Process",
        simulate: "Simulate Entry",
        enterqty: "Enter Quantity",
        material: "Material Correlation",
        unit: "Unit of Measure Correlation",
        reference: "Inform | Correct Reference",
        redetermine: "Redetermine Process",
        purchase: "Search Order",
        menuDanfe: "Danfe",
        menuDacte: "DACTE",
        ShowDanfe: "Show Danfe",
        ShowDacte: "Show DACTE",
        consultarStatus: "Query Status",
        rejeitar: "Reject",
        rejeitarDesconhecimento: "Unrecognized Operation",
        rejeitarNaoRealizada: "Operation Not Performed",
        assign: "Assign Purchase Document",
        unassign: "Unassign",
        conversion: "U.M. Conversion",
        bSimulate: "Simulate",
        bEnablePhysicalReceipt: "Enable Physical Receipt",
        duplicateItem: "Duplicate Item",
        deleteItem: "Delete NF-e",
        deleteCte: "Delete CT-e",
        deleteConfirmTitle: "Confirm deletion",
        deleteConfirmMsg: "Are you sure you want to delete",
        deleteConfirmSuffix: "fiscal document(s)? This action cannot be undone.",
        bDelete: "Delete",
        uploadXml: "Upload XML",
        uploadSend: "Send XML",
        bpdf: "Generate PDF",
        print: "Print",
        download: "Download",
        settings: "Configure columns",
        export: "Export",
        bRestore: "Restore default",
        bCancel: "Cancel",
        bConfirm: "Confirm",
        bClear: "Clear",
        bProcess: "Process",
        clearFilters: "Clear Filters",
        details: "Details",
        xml: "XML",
        history: "History",
        actions: "Actions",
        quickView: "Quick View",
        syncNow: "Sync Data Now",
        exportExcel: "Download Excel",
        downAllDanfe: "Download DANFE in bulk",
        downAllXml: "Download XML in bulk",
      },
      columns: {
        accessKey: "Key",
        messages: "Msg",
        company: "Company",
        plant: "Plant",
        supplierCnpj: "Supplier CNPJ",
        supplierCpf: "Supplier CPF",
        supplierName: "Supplier Name",
        destCnpj: "Recipient CNPJ",
        destName: "Recipient Name",
        cfop: "CFOP",
        process: "Process",
        step: "Step",
        xmlVersion: "XML Version",
        nfeNumber: "NF-e",
        series: "Series",
        issueDate: "Issue Date",
        issueTime: "Issue Time",
        createdDate: "Created Date",
        createdTime: "Created Time",
        sefazLog: "SEFAZ Log",
        sefazStatus: "SEFAZ Status",
        processStatus: "Proc. Status",
        rejectCode: "Rej. Code",
        ufOrigin: "Origin UF",
        ufDest: "Dest. UF",
        totalValue: "Total Value",
        sefazEvent: "SEFAZ Event",
        sequentialStep: "Step Sequence",
        executionDate: "Execution Date",
        executionTime: "Execution Time",
        userName: "User",
        status: "Status",
        errorDescription: "Error Description",
        amount: "Amount",
        date: "Date",
        cteNumber: "CT-e Number",
        carrierName: "Carrier",
        carrierCnpj: "Carrier CNPJ",
        natOp: "Operation Nature",
        rntrc: "RNTRC",
        modal: "Modal",
      },
      details: {
        taxdata: "Tax Data",
        issuer: "Issuer",
        recipient: "Recipient",
        number: "NFe Number and Series:",
        dateTime: "Issue Date and Time:",
        purpose: "Issue Purpose (NFe):",
        accesskey: "Access Key:",
        operation: "Nature of Operation:",
        protocol: "Protocol Number:",
        dateReceived: "SEFAZ Receipt Date and Time:",
        codStatus: "Status Code:",
        name: "Name:",
        cnpj: "CNPJ",
        address: "Address",
        ie: "State Registration",
        title: "Fiscal Document Details - NFe",
        header: "Header",
        item: "Item",
        total: "Total",
        transport: "Transport",
        payment: "Payment",
        additionalData: "Additional Data",
        itemsList: "Items List",
        itemDetails: "Item Details",
        itemTaxDetails: "Item Tax Details",
        productCode: "Product Code",
        productDesc: "Product Description",
        ncm: "NCM",
        benefitCode: "Tax Benefit Code",
        cfop: "CFOP",
        eanTrib: "Taxable EAN Code",
        orderItem: "Order / Item",
        uomCom: "Commercial Unit of Measure",
        qtyCom: "Commercial Quantity",
        unitPrice: "Unit Price",
        productValue: "Product Value",
        uomTrib: "Taxable Unit of Measure",
        qtyTrib: "Taxable Quantity",
        unitPriceTrib: "Taxable Unit Price",
        icms: "ICMS",
        ipi: "IPI",
        pis: "PIS",
        cofins: "COFINS",
        origem: "Origin",
        cst: "CST",
        framework: "Framework Code",
      },
      total: {
        baseCalc: "Tax Base Value:",
        icms: "ICMS Value:",
        icmsDesonerado: "ICMS Exempted Value:",
        fcpUfDest: "FCP Dest. UF Value:",
        icmsUfDest: "ICMS Dest. UF Value:",
        icmsUfRemet: "ICMS Sender UF Value:",
        fcp: "FCP Value:",
        baseCalcSt: "ST Tax Base:",
        st: "ST Value:",
        fcpSt: "FCP ST Value:",
        fcpStRet: "FCP ST Ret Value:",
        productValue: "Product Value:",
        freight: "Freight Value:",
        insurance: "Insurance Value:",
        discount: "Discount Value:",
        ii: "Import Tax Value:",
        ipi: "IPI Value:",
        ipiDev: "IPI Dev Value:",
        pis: "PIS Value:",
        cofins: "COFINS Value:",
        others: "Other Values:",
        nf: "Invoice Value:",
      },
      transport: {
        freightMode: "Freight Mode:",
        cnpj: "CNPJ:",
        name: "Name:",
        ie: "State Registration",
        address: "Address",
        city: "City",
        uf: "State:",
        volumeTitle: "Volume",
        volumeQty: "Volume Quantity:",
        volumeKind: "Kind",
        netWeight: "Net Weight",
        grossWeight: "Gross Weight",
        carrierTitle: "Carrier",
      },
      payment: {
        invoice: "Invoice",
        invoiveNumber: "Invoice Number",
        value: "Original Value",
        discount: "Discount Value",
        netValue: "Net Value",
        duplicate: "Duplicate",
        numberDuplicate: "Duplicate Number",
        dueDate: "Due Date",
        valueDuplicate: "Duplicate Value",
        details: "Payment Details",
        indicator: "Payment Method Indicator",
        paymentMethod: "Payment Method",
        paymentAmount: "Payment Amount",
      },
      additional: {
        title: "Additional Information",
      },
      assing: {
        title: "Purchase Document Assignment",
        assing: "Order Assignment",
        item: "NFe Item",
        itemDescr: "Item Description",
        qty: "Quantity",
        unit: "NFe Unit of Measure",
        purchaseOrderItem: "Purchase Doc. / Item",
        purchaseOrder: "SAP Purchase Doc.",
        poItem: "Order Item",
        purchaseItem: "SAP Purchase Doc. Item",
        purchaseOrderItemDescr: "Item Description",
        processType: "Process Type",
        numberNfe: "NFe Number",
        emitterName: "Issuer Name",
        emitterCnpj: "Issuer CNPJ",
        nameDest: "Recipient Name",
        cnpjDest: "Recipient CNPJ",
        itemCtg: "Item Category",
        materialXml: "XML Material",
        descMaterialXml: "XML Material Description",
        materialErp: "ERP Material",
        descMaterialErp: "ERP Material Description",
        pendingItems: "Pending NF-e Items",
        pendingOrder: "Available Order Items",
        message: "Message",
        unitErp: "ERP Unit of Measure",
        unitMeasurementConversion: "Unit of Measure Conversion",
        msgid: "ID / No.",
      },
      enterQty: {
        title: "Enter Quantity",
        receipt: "Receipt",
        deposit: "Warehouse",
        center: "Plant",
        batch: "Batch",
        subitem: "Subitem",
        select: "Select",
        message: "Message",
        batchRequired: "Batch is required",
        warehouseRequired: "Warehouse is required",
        invalidQty: "Invalid quantity",
        qtyExceeded: "Item {{itemKey}}: total quantity entered ({{splitQty}}) exceeds item quantity ({{originalQty}}).",
        qtyBelow: "Item {{itemKey}}: total quantity entered ({{splitQty}}) is below item quantity ({{originalQty}}).",
        tableErrors: "There are errors in the table. Please fix before saving.",
        dataSaved: "Data saved successfully.",
        saving: "Saving... Creating goods receipt.",
        saveSuccess: "Goods receipt created successfully!",
        saveError: "Error: {{msg}}",
      },
      document: {
        title: "Generated Documents",
        noDocuments: "No generated documents found.",
      },
      simulate: {
        title: "Escotta Inbound Automation - Simulation - NFe",
        generalData: "General Data",
        taxesCalculated: "Calculated Taxes",
        message: "Message",
        material: "Material",
        origem: "Material Origin",
        ncm: "NCM",
        qty: "Quantity",
        uom: "Unit of Measure",
        totalValue: "Total Value",
        qtyPo: "Purchase Order Quantity",
        purchaseOrder: "Purchase Doc. / Item",
        itemType: "Item Type",
        cfop: "CFOP",
        iva: "Tax Code",
        taxDocumentData: "Fiscal Doc. Data",
        simulationData: "Simulation Data",
        item: "Item",
      },
      uploadXml: {
        title: "Upload XML NF-e / CT-e",
        pageTitle: "Upload XML NF-e / CT-e",
        subtitle: "XML File Import",
        description: "Select or drag NF-e XML files for submission.",
        dragTitle: "Drag XML files here",
        dragSubtitle: "or click to select files from your computer",
        selectFiles: "Select files",
        selectedFiles: "Selected files",
        empty: "No XML file selected yet.",
        errorProcess: "Error processing XML",
        errorUpload: "Error uploading XML",
      },
      history: {
        title: "Fiscal Document History",
        subtitle: "History",
        documents: "Document: ",
        fetchError: "Error fetching history",
      },
      danfe: {
        noneFound: "No DANFE found.",
        productData: "Products / Services Data",
        printedIn: "Printed on ",
        productCode: "Product Code",
        description: "Product / Service Description",
        ncm: "ncm",
        cst: "cst",
        cfop: "cfop",
        un: "unit",
        qty: "qty",
        unitValue: "Unit Value",
        totalValue: "Total Value",
        bicms: "ICMS Tax Base",
        vicms: "ICMS Value",
        vipi: "IPI Value",
        ticms: "ICMS Rate",
        tipi: "IPI Rate",
        messageReceipt: "We received from {{nameEmit}} the products and/or services listed in the electronic invoice indicated below. Issue: {{date}} Total value: {{totalValue}} Recipient: {{nameDest}}",
        dateReceipt: "Receipt Date",
        identSing: "Recipient Identification and Signature",
        nfe: "NF-e",
        number: "No.",
        serie: "Series",
        destReme: "Recipient / Sender",
        companyName: "Name / Company Name",
        cnpj: "CNPJ / CPF",
        dateIssue: "Issue Date",
        address: "Address",
        neighborhood: "District / Neighborhood",
        cep: "ZIP Code",
        arrivalDate: "Departure / Entry Date",
        arrivalTime: "Departure / Entry Time",
        local: "City",
        uf: "State",
        fone: "Phone / Fax",
        ie: "State Registration",
        invoice: "Invoice / Duplicate",
        num: "No.",
        dueDates: "Due",
        value: "Value",
        taxCalculation: "Tax Calculation",
        vicmsufr: "ICMS Sender UF",
        vicmsufd: "FCP Dest. UF",
        totalValueP: "Total Products Value",
        shippingCost: "Freight Value",
        insuranceValue: "Insurance Value",
        discount: "Discount",
        otherExpenses: "Other Expenses",
        totalTaxedVvalue: "Total Tax Value",
        totalValueReceipt: "Total Invoice Value",
        transporter: "Carrier / Transported Volumes",
        shippingCosts: "Freight Responsibility",
        anttCode: "ANTT Code",
        vehiclePlate: "Vehicle Plate",
        species: "Species",
        mark: "Brand",
        numbering: "Numbering",
        grossWeight: "Gross Weight",
        additionalInformation: "Additional Information",
        reservedTaxAuth: "Reserved for Tax Authority",
        additionalData: "Additional Data",
        issueridentification: "Issuer Identification",
        danfe: "danfe",
        auxiliaryInvoice: "Auxiliary Invoice Document",
        electronicTax: "Electronic Tax",
        entry: "0 - Entry",
        exit: "1 - Exit",
        sheet: "Sheet",
        accessKey: "Access Key",
        verificationAuthenticity: "Authenticity check at the national NF-e portal",
        sefazWebsite: "www.nfe.fazenda.gov.br/portal or at the Authorizing SEFAZ website",
        natureOperation: "Nature of Operation",
        authorizationProtocol: "Use Authorization Protocol",
        iest: "State Registration of Tax Substitute",
        im: "Municipal Registration",
        invoce: "Invoice / Duplicate",
        bicmsst: "ICMS S.T. Tax Base",
        vicmsst: "ICMS Substitute Value",
        vii: "Import Tax Value",
      },
      assignment: {
        simNoMessages: "Simulation completed with no messages.",
        simError: "Simulation error: {{msg}}",
        saveSuccess: "Order assigned successfully.",
        unassignSuccess: "Unassignment saved successfully.",
        saveSuccessContinuing: "Order assigned successfully. Continuing process...",
      },
      errors: {
        noRowSelected: "No row selected",
        accessKeyNotFound: "Access key not found in selected row",
        xmlNotReturned: "XML not returned by server",
      },
      log: {
        title: "View error messages",
        subtitle: "Process Messages",
        step: "Step",
        sequentialStep: "Sequential",
        Status: "Status",
        number: "ID / No.",
        message: "Message",
      },
      message: {
        msg0001: "Could not find NF data in state. Go back to the list and select an NF to assign.",
        msg0002: "No order items found for the given criteria",
        msg0003: "order item(s) found.",
        msg0004: "Select an XML item and an order item to assign.",
        msg0005: "Could not locate the selected items.",
        msg0006: "Assignment completed successfully",
        msg0007: "Assignment not found.",
        msg0008: "Data saved successfully.",
        msg0009: "XML item {{item}} assigned to order {{po}}/{{poItem}}.",
        msg0010: "Select an assignment to unassign.",
        msg0011: "Assignment removed from XML item {{item}}.",
        msg0012: "Conversion registered: {{fromUom}} → {{toUom}} (factor {{factor}}).",
        msg0013: "XML item {{item}} is already assigned.",
        msg0014: "Invalid XML.",
        msg0015: "Error reading XML",
        msg0016: "Select at least one valid XML file.",
        msg0017: "Error processing XML.",
        msg0018: "No file selected",
        erroBuscaPedido: "Could not query orders in SAP PI. {{detalhe}}",
      },
      api: {
        accessKey: {
          required: "Access key is required",
          arrayRequired: "Access keys array is required",
        },
        nfe: {
          notFound: "NF-e not found",
        },
        items: {
          fetchError: "Error fetching items",
          saveError: "Error saving data",
        },
        documents: {
          fetchError: "Error fetching documents",
        },
        header: {
          fetchError: "Error fetching fiscal documents",
        },
        history: {
          fetchError: "Internal error fetching history",
        },
        xml: {
          notFound: "XML not found for the provided access key",
          fetchError: "Error fetching XML",
          generateError: "Error generating XML files",
        },
        upload: {
          noDocument: "No document sent",
        },
        danfe: {
          generateError: "Error generating DANFE PDFs",
        },
        assignment: {
          locked: "Item locked by another user",
          stepNotFound: "Assignment step not found for this process",
          saveError: "Error saving assignment",
        },
        delete: {
          required: "Access keys list is required",
          error: "Error deleting NF-e",
        },
        process: {
          fetchError: "Error fetching processes",
        },
        steps: {
          fetchError: "Error fetching steps",
        },
        continue: {
          locked: "Item locked by another user",
          stepPending: "Current item step is not yet completed",
          error: "Error continuing processing",
        },
      },
      admin: {
        pages: {
          certificados: "Digital Certificates",
          empresas: "Companies",
          processos: "Processes",
          cfop: "CFOP Determination",
          etapas: "Process Steps",
          integrationLog: "Integration Log",
        },
        col: {
          cnpj: "CNPJ",
          empresa: "Company",
          tempoJob: "Job Time (s)",
          lastNsu: "Last NSU",
          certificado: "Certificate",
          razaoSocial: "Company Name",
          codSap: "SAP Code",
          centro: "Plant",
          ativaCol: "Active",
          codigo: "Code",
          descricao: "Description",
          cfop: "CFOP",
          processo: "Process",
          etapa: "Step",
          funcaoTx: "TX Function",
          automaticaCol: "Automatic",
          obrigatoriaCol: "Mandatory",
          dataHora: "Date / Time",
          tipo: "Type",
          payloadEnvio: "Request payload",
          payloadRetorno: "Response payload",
        },
        grid: {
          certificados: "Certificates by Company",
          empresas: "Registered Companies",
          processos: "Process Types",
          etapas: "Configured Steps",
          cfop: "CFOP × Process Link",
        },
        dialog: {
          confirmDelete: "Confirm Deletion",
          editCertificado: "Edit Certificate",
          newCertificado: "New Certificate",
          editEmpresa: "Edit Company",
          newEmpresa: "New Company",
          editProcesso: "Edit Process",
          newProcesso: "New Process",
          editCfop: "Edit CFOP",
          newCfop: "New CFOP",
          editEtapa: "Edit Step",
          newEtapa: "New Step",
          callDetails: "Call details",
        },
        required: {
          empresa: "Company is required",
          cnpj: "CNPJ is required",
          cfop: "CFOP is required",
          processStep: "Process and step are required",
          processCode: "Process code is required",
        },
        success: {
          certUpdated: "Certificate updated",
          certSaved: "Certificate saved",
          certDeleted: "Certificate(s) deleted",
          empresaUpdated: "Company updated",
          empresaCreated: "Company created",
          empresaDeleted: "Company(ies) deleted",
          processUpdated: "Process updated",
          processCreated: "Process created",
          processDeleted: "Process(es) deleted",
          cfopUpdated: "CFOP updated",
          cfopCreated: "CFOP created",
          cfopDeleted: "CFOP(s) deleted",
          stepUpdated: "Step updated",
          stepCreated: "Step created",
          stepDeleted: "Step deleted",
        },
        confirm: {
          deleteCertificado: "Delete {{count}} certificate(s)? This action cannot be undone.",
          deleteEmpresa: "Delete {{count}} company(ies)? This action cannot be undone.",
          deleteProcesso: "Delete {{count}} process(es)? This action cannot be undone.",
          deleteCfop: "Delete {{count}} CFOP(s)? This action cannot be undone.",
          deleteEtapa: "Delete the selected step? This action cannot be undone.",
        },
        buttons: {
          cancel: "Cancel",
          deleting: "Deleting...",
          delete: "Delete",
          buscar: "Search",
          limpar: "Clear",
          verDetalhes: "View details",
          close: "Close",
        },
        label: {
          empresaAtiva: "Active company",
          ativa: "Active",
          automatica: "Automatic",
          obrigatoria: "Mandatory",
          todos: "All",
        },
        helper: {
          certBase64: "Paste the A1 certificate (PFX) content in Base64",
          certPassword: "PFX file password (leave empty if no password)",
          functionTx: "Ex: SAVE_NFE_XML, ZF_ASSIGN_PURCHASE_ORDER",
        },
        filter: {
          all: "All",
          none: "— None —",
          filtros: "Filters",
          tipoIntegracao: "Integration type",
          data: "Date",
          cnpj: "CNPJ",
          status: "Status",
        },
        detail: {
          dataHora: "DATE / TIME",
          tipo: "TYPE",
          cnpj: "CNPJ",
          status: "STATUS",
        },
      },
      sefaz: {
        distribute: {
          cardTitle: "Electronic Fiscal Document Distribution",
          cardDesc: "Requests from SEFAZ all DFe documents of interest to the CNPJ starting from the last received NSU. Complete NF-e documents are imported automatically.",
          empresa: "Company (Certificate)",
          lastNsu: "Last NSU:",
          nsuResetTooltip: "Reset NSU — next query will fetch all documents from the beginning",
          nsuReset: "NSU reset — next query will fetch all documents",
          nsuResetError: "Error resetting NSU",
          selectCompany: "Select a company",
          noNewDocs: "No new documents at SEFAZ",
          docsReceived: "{{count}} document(s) received — {{saved}} saved",
          noNewDocsFound: "No new documents found at SEFAZ for this CNPJ.",
          docsReceivedTitle: "Documents received ({{count}})",
          savedCount: "{{count}} saved",
          errorsCount: "{{count}} error(s)",
          querying: "Querying SEFAZ...",
          distribute: "Distribute DFe",
          colNsu: "NSU",
          colTipo: "Type",
          colChave: "Access Key",
          colStatus: "Status",
          colDetalhe: "Detail",
        },
        schema: {
          procNFe: "Complete NF-e",
          resNFe: "NF-e Summary",
          procCTe: "Complete CT-e",
          resCTe: "CT-e Summary",
          procEvento: "Complete Event",
          resEvento: "Event Summary",
        },
        status: {
          saved: "Saved",
          xmlUpdated: "XML Updated",
          alreadyExists: "Already Exists",
          received: "Received",
          error: "Error",
        },
        consulta: {
          title: "Status Query — SEFAZ {{uf}}",
          protocol: "Protocol",
          dhProtocolo: "Protocol Date",
          dhRecbto: "Response Date",
          detalhe: "Detail",
        },
      },
      nfe: {
        error: {
          assignmentNotAllowed: "Assignment not allowed for the current document step.",
          assignmentNotAllowedStep: "Assignment not allowed. Next step: {{step}}",
          qtyNotAllowed: "Enter Quantity not allowed for the current document step.",
          qtyNotAllowedStep: "Enter Quantity not allowed. Next step: {{step}}",
        },
        validation: {
          justificationMin: "Justification must be at least 15 characters.",
          justificationHelper: "{{length}}/255 — minimum 15 characters",
        },
        evento: {
          successDesconhecimento: "Event \"Unrecognized Operation\" sent successfully.",
          successNaoRealizada: "Event \"Operation Not Performed\" sent successfully.",
          confirmDesconhecimento: "Confirm sending the Unrecognized Operation event for this NF-e?",
          justificativaLabel: "Enter the justification for Operation Not Performed (15–255 characters):",
        },
      },
      toolbar: {
        today: "Today",
        at: "at"
      }
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: getBrowserLanguage(),
  fallbackLng: "pt",
  interpolation: { escapeValue: false },
});

export default i18n;